import { createRecord, deleteRecord, updateRecord } from "../../server/fetchFunctions";

type SetValue = React.Dispatch<React.SetStateAction<any>>;

export const handleStatusChange = (index: number, property: string, value: any, setStatus: SetValue) => {
  setStatus((prev: any[]) => prev.map((item, i) => (i === index ? { ...item, [property]: value.target.value } : item)));
};

export const handleNewStatus = async (newStatus: any, setStatus: SetValue, statuses: any, setNewStatus: SetValue) => {
  const response = await createRecord("status", newStatus);
  setStatus((prev: any[]) => [...prev, response]);
  setNewStatus({ status_name: "", color: "" });
};

export const handleStatusUpdate = async (id: number, value: any) => {
  await updateRecord("status", id, value);
};

export const handleStatusDelete = async (id: number, setStatus: SetValue) => {
  await deleteRecord("status", id);
  setStatus((prev: any[]) => prev.filter((item) => item.id !== id));
};
